export const DD_LINK_COLUMN_KEY = 'linkColumn';
